<template>
  <div class="animated fadeIn">
    <b-container fluid class="noticesView">
      <notices-list ref="noticesList" @showNoticeModal="handleShowNoticeModal" @showDeleteNoticeModal="handleDeleteNoticeModal"/>
      <notice-modal ref="noticeModal" @showAlertNotice="handleAlertNotice" :notice="notice" :action="action"></notice-modal>
      <notice-delete-modal ref="noticeDeleteModal" @showAlertNotice="handleAlertNotice" :notice="notice"></notice-delete-modal>
    </b-container>
  </div>
</template>
<script>
import NoticesList from '@/components/notices/NoticesList.vue'
import NoticeModal from '@/components/notices/NoticeModal.vue'
import NoticeDeleteModal from '@/components/notices/NoticeDeleteModal.vue'
export default {
  name: 'noticesView',
  components: { NoticesList, NoticeModal, NoticeDeleteModal },
  data () {
    return {
      notice: {
        title: '',
        message: '',
        date: ''
      },
      action: 'create'
    }
  },
  methods: {
    handleShowNoticeModal (value) {
      this.notice = value.notice
      this.action = value.action
      this.$refs.noticeModal.show()
    },
    handleDeleteNoticeModal (notice) {
      this.notice = notice
      this.$refs.noticeDeleteModal.show()
    },
    handleAlertNotice (value) {
      this.$refs.noticesList.showAlertNoticesList(value.text, value.variant)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/NoticesView.vue